/**
 * Standardized error classes for the application.
 */

export class HttpError extends Error {
  public readonly statusCode: number;
  public readonly statusText: string;

  constructor(message: string, statusCode: number, statusText?: string) {
    super(message);
    this.name = 'HttpError';
    this.statusCode = statusCode;
    this.statusText = statusText || this.getStatusText(statusCode);
  }

  private getStatusText(statusCode: number): string {
    const statusTexts: Record<number, string> = {
      400: 'Bad Request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Not Found',
      413: 'Payload Too Large',
      415: 'Unsupported Media Type',
      429: 'Too Many Requests',
      500: 'Internal Server Error',
      503: 'Service Unavailable',
    };
    return statusTexts[statusCode] || 'Unknown Error';
  }
}

export class NotLoggedInError extends Error {
  constructor(message: string = 'User is not logged in') {
    super(message);
    this.name = 'NotLoggedInError';
  }
}

export class GeneralError extends Error {
  public readonly code?: string;
  public readonly context?: Record<string, unknown>;

  constructor(message: string, code?: string, context?: Record<string, unknown>) {
    super(message);
    this.name = 'GeneralError';
    this.code = code;
    this.context = context;
  }
}
